import {
  plansApiTypeOptions,
  planTreeTypeFilterOptions
} from '../../react-query/plan/constants'
import { useGetPlanTreeInfinityQuery } from '../../react-query/plan/query/use-get-plan-tree-infinity-query'
import { recursiveListTypeOptions } from './constants'
import {
  projectTreeTypeFilterOptions,
  useGetProjectTreeQuery
} from '../../react-query/project/query/use-get-project-tree-query'

export const useFolderTreeQuery = ({
  listType,
  folderId,
  planRootFolderId,
  search
}) => {
  const projectQuery = useGetProjectTreeQuery({
    folderId,
    params: { search, typeFilter: projectTreeTypeFilterOptions.FOLDERS },
    options: { enabled: listType === recursiveListTypeOptions.PROJECT }
  })

  const planQuery = useGetPlanTreeInfinityQuery({
    id: folderId ?? planRootFolderId,
    type: plansApiTypeOptions.FOLDERS,
    typeFilter: planTreeTypeFilterOptions.FOLDERS,
    options: {
      enabled:
        listType === recursiveListTypeOptions.PLAN &&
        (!!planRootFolderId || !!folderId)
    }
  })

  return listType === recursiveListTypeOptions.PROJECT
    ? projectQuery
    : planQuery
}
